(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["comparatif-vizi"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vb-comparison')) {

  customElements.define('vb-comparison', class extends HTMLElement {

    connectedCallback() {

      this.controller?.abort();

      this.controller = new AbortController();

      const options = { signal: this.controller.signal };

      this.dialog = this.querySelector('dialog');

      this.trigger = this.querySelector('.vb-comparison__trigger');

      if (!this.dialog || !this.trigger) return;

      this.data = JSON.parse(this.querySelector('[data-vb-comparison-data]').textContent);

      for (const cell of this.querySelectorAll('tbody td')) {

      if (cell.textContent.trim() === 'Canon SELPHY CP1500') cell.textContent = this.data.printer;
      if (/^Canon(?: EOS)? 2000D$/i.test(cell.textContent.trim())) cell.textContent = 'Canon EOS R50';

    }

    const giftRow = this.querySelector('.vb-comparison__gift-row');
    const warrantyRow = Array.from(this.querySelectorAll('tbody tr')).find(row => {
      const label = row.querySelector('th[scope="row"]')?.textContent.trim().toLocaleLowerCase('fr');
      return label && /\bgarantie\b/.test(label);
    });
    if (giftRow && warrantyRow) warrantyRow.after(giftRow);

    this.syncPrices();

      this.trigger.addEventListener('click', () => {

        if (this.dialog.open) return;

        this.syncPrices();

        this.dialog.showModal();

        this.previousOverflow = document.documentElement.style.overflow;

        document.documentElement.style.overflow = 'hidden';

        this.locked = true;

      }, options);

      this.querySelector('.vb-comparison__close').addEventListener('click', () => this.dialog.close(), options);

      this.dialog.addEventListener('click', (event) => {

        if (event.target !== this.dialog) return;

        const rect = this.dialog.getBoundingClientRect();

        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();

      }, options);

      this.dialog.addEventListener('close', () => {

        this.unlock();

        if (this.trigger.isConnected) this.trigger.focus({ preventScroll: true });

      }, options);

    }

    syncPrices() {

      const form = this.closest('form');

      const currentId = form?.querySelector('[name="id"]')?.value;

      const current = this.data.variants.find(v => String(v.id) === String(currentId)) || this.data.variants.find(v => v.id === this.data.selected);

      let visibleCount = 0;

      for (const header of this.querySelectorAll('thead [data-pack]')) {

        const key = header.dataset.pack;

        const match = (this.data.matches[key] || '').trim().toLocaleLowerCase();

        const candidates = match ? this.data.variants.filter(v => (v.options[this.data.packIndex] || '').toLocaleLowerCase().includes(match)) : [];

        const visible = header.dataset.enabled === 'true' && candidates.length > 0;

        if (visible) visibleCount++;

        for (const cell of this.querySelectorAll(`[data-pack="${key}"]`)) cell.hidden = !visible;

        const variant = current && candidates.find(v => v.options.every((value, index) => index === this.data.packIndex || value === current.options[index]));

        header.querySelector('[data-pack-price]').textContent = variant ? variant.money : this.data.missing;

      }

      this.style.setProperty('--vb-visible-packs', Math.max(visibleCount, 1));

    }

    unlock() {

      if (!this.locked) return;

      document.documentElement.style.overflow = this.previousOverflow;

      this.locked = false;

    }

    disconnectedCallback() {

      if (this.dialog?.open) this.dialog.close();

      this.unlock();

      this.controller?.abort();

    }

  });

}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["reviews-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vb-product-proof')) {
    class VBProductProof extends HTMLElement {
      connectedCallback() {
        this.handleClick = this.onClick.bind(this);
        this.handleLoad = this.refresh.bind(this);
        this.addEventListener('click', this.handleClick);
        document.addEventListener('shopify:section:load', this.handleLoad);
        document.addEventListener('DOMContentLoaded', this.handleLoad);
        this.refresh();
        this.timer = setTimeout(() => this.refresh(), 500);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        document.removeEventListener('shopify:section:load', this.handleLoad);
        document.removeEventListener('DOMContentLoaded', this.handleLoad);
        clearTimeout(this.timer);
      }
      target() {
        const id = (this.dataset.target || '').trim().replace(/^#/, '');
        if (id) return document.getElementById(id);
        return Array.from(document.querySelectorAll('section.ph-avis-trust[id]')).find(section => section.getClientRects().length > 0) || null;
      }
      refresh() {
        const link = this.querySelector('.vb-proof__link');
        if (!link) return;
        const target = this.target();
        if (target) link.setAttribute('href', '#' + target.id);
        let rating = this.dataset.rating || '';
        let count = this.dataset.count || '';
        const numericRating = Number(String(rating).replace(',', '.').trim());
        const validRating = String(rating).trim() !== '' && Number.isFinite(numericRating) && numericRating >= 0 && numericRating <= 5;
        const ratingEl = this.querySelector('.vb-proof__rating');
        ratingEl.hidden = !validRating;
        if (validRating) {
          const displayRating = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(numericRating);
          this.querySelector('.vb-proof__score').textContent = displayRating + '/5';
          ratingEl.setAttribute('aria-label', displayRating + ' sur 5');
          this.querySelectorAll('[data-star-fill]').forEach((rect, index) => rect.setAttribute('width', String(Math.max(0, Math.min(1, numericRating - index)) * 24)));
        }
        const cleanCount = String(count).replace(/[ \u00a0\u202f]/g, '');
        const validCount = /^\d+$/.test(cleanCount) && Number.isSafeInteger(Number(cleanCount)) && Number(cleanCount) > 0;
        const countEl = this.querySelector('.vb-proof__count');
        countEl.hidden = !validCount;
        if (validCount) countEl.textContent = '(' + new Intl.NumberFormat('fr-FR').format(Number(cleanCount)) + ' ' + (this.dataset.countLabel || '').trim() + ')';
      }
      onClick(event) {
        if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (!event.target.closest('.vb-proof__link')) return;
        const target = this.target();
        if (!target) return;
        event.preventDefault();
        const offset = parseFloat(getComputedStyle(this).getPropertyValue('--vbp-scroll-offset')) || 0;
        const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset);
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top, behavior: reducedMotion ? 'instant' : 'smooth' });
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      }
    }
    customElements.define('vb-product-proof', VBProductProof);
  }
  } catch(e) { console.error(e); }
})();

})();
